import React from 'react';
import {
    Box,
    Container,
    Typography,
    Paper,
    Divider,
} from '@mui/material';

const Privacy = () => {
    return (
        <Box sx={{ py: 8, bgcolor: '#f8fafc' }}>
            <Container maxWidth="lg">
                <Paper elevation={0} sx={{ p: 4, borderRadius: 2 }}>
                    <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 700, color: '#1a202c', mb: 4 }}>
                        Privacy Policy
                    </Typography>

                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: '#2d3748', mt: 4 }}>
                        1. Information We Collect
                    </Typography>
                    <Typography paragraph sx={{ color: '#4a5568', mb: 3 }}>
                        We collect information that you provide directly to us, including personal information such as your name, email address, and school details when you register for an account or use our services.
                    </Typography>

                    <Divider sx={{ my: 4 }} />

                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: '#2d3748' }}>
                        2. How We Use Your Information
                    </Typography>
                    <Typography paragraph sx={{ color: '#4a5568', mb: 3 }}>
                        We use the information we collect to:
                        • Provide, maintain, and improve our services
                        • Process your transactions
                        • Send you technical notices and support messages
                        • Respond to your comments and questions
                    </Typography>

                    <Divider sx={{ my: 4 }} />

                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: '#2d3748' }}>
                        3. Data Security
                    </Typography>
                    <Typography paragraph sx={{ color: '#4a5568', mb: 3 }}>
                        We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
                    </Typography>

                    <Divider sx={{ my: 4 }} />

                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: '#2d3748' }}>
                        4. Children's Privacy
                    </Typography>
                    <Typography paragraph sx={{ color: '#4a5568', mb: 3 }}>
                        Our services are designed for educational institutions and comply with applicable laws regarding children's privacy. We collect and process children's data only with appropriate parental or guardian consent.
                    </Typography>

                    <Divider sx={{ my: 4 }} />

                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: '#2d3748' }}>
                        5. Changes to This Policy
                    </Typography>
                    <Typography paragraph sx={{ color: '#4a5568', mb: 3 }}>
                        We may update this privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page and updating the effective date.
                    </Typography>

                    <Box sx={{ mt: 6 }}>
                        <Typography variant="body2" sx={{ color: '#718096' }}>
                            Last updated: September 10, 2025
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#718096', mt: 1 }}>
                            If you have any questions about this Privacy Policy, please contact us at privacy@scholiq.com
                        </Typography>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default Privacy;
